/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from 'react';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIButton from 'UIComponents/button/UIButton';
import H4 from 'UIComponents/elements/headings/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NEW_INSERT_FEATURE_KEYS = ['tables', 'callouts', 'anchors'];
const I18nKey = suffix => `knowledgeContentUI.edit.newInsertMenuPopover.${suffix}`;
function NewInsertPopover(props) {
  const insertMenu = useRef();
  const [__foundInsertMenu, setFoundInsertMenu] = useState(false);
  const {
    open,
    toolbarRef
  } = props;
  useEffect(() => {
    if (toolbarRef.current) {
      const el = toolbarRef.current.querySelector('[data-test-id="insert-menu"]');
      if (el) {
        insertMenu.current = el;
        setFoundInsertMenu(true);
      } else {
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'false' is not assignable to type 'undefined'... Remove this comment to see the full error message
        insertMenu.current = false;
        setFoundInsertMenu(false);
      }
    }
  });
  const target = insertMenu.current;
  return /*#__PURE__*/_jsx(UIPopover, {
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: I18nKey('header')
        })
      }),
      body: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: I18nKey('featureListLabel')
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("ul", {
          children: NEW_INSERT_FEATURE_KEYS.map(key => /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: I18nKey(`features.${key}`)
            })
          }, key))
        })]
      }),
      footer: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "new-editor-features-popover-close",
          onClick: props.onDismiss,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: I18nKey('dismissButton')
          })
        })
      })
    },
    className: "mce-insert-menu-popover"
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    ,
    disabled: !target,
    open: open,
    target: target,
    use: "shepherd",
    width: 350,
    placement: "bottom"
  });
}
export default NewInsertPopover;